<ng-container *ngIf="serverError">
  <div class="modal-header">
    <h4 class="modal-title">Server Error: {{ serverError }}</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</ng-container>

<ng-container *ngIf="documentNotFound">
  <div class="modal-header">
    <h4 class="modal-title">Document Not Found</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</ng-container>

<ng-container *ngIf="!(serverError || documentNotFound)">
  <div class="modal-header">
    <h4 class="modal-title">Invalid Document</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body" *ngIf="!loadingDocument">

    <table>
      <tr>
        <td class="pr-3">Document Name:</td>
        <td>{{ document.document_name }}</td>
      </tr>
      <tr>
        <td class="pr-3">Document Completed At:</td>
        <td>
          {{ timeStringFromISO8601(document.document_completed_at) }},
          {{ dateStringFromISO8601(document.document_completed_at) }}
        </td>
      </tr>
      <tr>
        <td class="pr-3">Document PDF:</td>
        <td>
          <a [href]="document.document_pdf" target="_blank">Link</a>
        </td>
      </tr>
      <ng-container *ngFor="let relatedCustomer of document.related_customers">
        <tr style="height: 10px;"></tr>
        <tr>
          <td class="pr-3">Customer Name:</td>
          <td>
            <a [routerLink]="['/customers', relatedCustomer.id.toString()]" target="_blank">
              {{ relatedCustomer.first_name }} {{ relatedCustomer.last_name }}
            </a>
          </td>
        </tr>
        <tr>
          <td class="pr-3">Birthday:</td>
          <td>{{ dateStringFromISO8601(relatedCustomer.birthday) }}</td>
        </tr>
        <tr>
          <td class="pr-3">Email Address:</td>
          <td *ngIf="relatedCustomer.email">{{ relatedCustomer.email }}</td>
          <td *ngIf="!relatedCustomer.email" class="text-muted">None given</td>
        </tr>
        <tr>
          <td class="pr-3">Telephone:</td>
          <td *ngIf="relatedCustomer.telephone">{{ relatedCustomer.telephone }}</td>
          <td *ngIf="!relatedCustomer.telephone" class="text-muted">None given</td>
        </tr>
      </ng-container>
      <ng-container *ngIf="document.dismissed_by_id">
        <tr style="height: 10px;"></tr>
        <tr>
          <td class="pr-3">Dismissed By:</td>
          <td>{{ document.dismissed_by_email }}</td>
        </tr>
        <tr>
          <td class="pr-3">Dismissed At:</td>
          <td>
            {{ timeStringFromISO8601(document.dismissed_at) }},
            {{ dateStringFromISO8601(document.dismissed_at) }}
          </td>
        </tr>
      </ng-container>
      <ng-container *ngIf="document.resolved_by_id">
        <tr style="height: 10px;"></tr>
        <tr>
          <td class="pr-3">Resolved By:</td>
          <td>{{ document.resolved_by_email }}</td>
        </tr>
        <tr>
          <td class="pr-3">Resolved At:</td>
          <td>
            {{ timeStringFromISO8601(document.resolved_at) }},
            {{ dateStringFromISO8601(document.resolved_at) }}
          </td>
        </tr>
        <tr>
          <td class="pr-3">Resolution:</td>
          <td>
            {{ document.is_denied_staff_approval ? 'Denied' : 'Approved' }}
          </td>
        </tr>
      </ng-container>
    </table>

  </div>

  <div class="modal-body" *ngIf="loadingDocument">
    <p>Loading...</p>
  </div>

  <div class="modal-footer">

    <button type="button" class="btn btn-secondary"
            (click)="activeModal.close()">
      Close
    </button>

  </div>
</ng-container>
